import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CompileModule } from "p3x-angular-compile"
import {Promise} from 'es6-promise'

import { AppComponent } from './app.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { HomeComponent } from './views/home/home.component';
import { CounterComponent } from './views/counter/counter.component';
import { FetchDataComponent } from './views/fetch-data/fetch-data.component';
import { LiveViewComponent } from './_helpers/livew-view/live-view.component';
import { SideMenuLiveViewComponent } from '../app/components/side-menu-live-view/side-menu-live-view.component';
import { AddProjetoComponent } from '../app/components/add-projeto/add-projeto.component';
import { AddTenantComponent } from '../app/components/add-tenant/add-tenant.component';
import { AddDatasetComponent } from '../app/components/add-dataset/add-dataset.component';
import { AddTemplateComponent } from '../app/components/add-template/add-template.component';
import { AddCabecalhoComponent } from '../app/components/add-cabecalho/add-cabecalho.component';
import { EditorTemplateComponent } from './views/editor-template/editor-template.component';
import { EditorCabecalhoComponent } from './views/editor-cabecalho/editor-cabecalho.component';
import { JsonViewerComponent } from './_helpers/json-viewer/json-viewer.component';
import { ReportComponent } from './views/report/report.component';
import { ModalComponent } from './_helpers/modal/modal.component';
import { DynamicComponent } from './_helpers/dynamic/dynamic.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CdkTableModule } from '@angular/cdk/table';

import { SanitizeHtmlPipe } from './pipes/sanitize.pipe';
import { CompileDirective } from './views/directives/compile.directive';

import { RequestsService } from './services/requests.service';

import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { HttpConfigInterceptor } from './interceptors/httpError.interceptor';


import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastsContainer } from './_helpers/toast/toast-container.component';
import { ToastComponent } from './_helpers/toast/toast.component';

import { MonacoEditorModule } from '@materia-ui/ngx-monaco-editor';
import { ModalperguntaComponent } from './_helpers/modalpergunta/modalpergunta.component';
import { ModalcloneComponent } from './_helpers/modalclone/modalclone.component';

import { AuthGuard } from './_helpers/auth/auth.guard';

import { ReactiveFormsModule } from '@angular/forms';
import { ModaltooltipComponent } from './_helpers/modaltooltip/modaltooltip.component';


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    LiveViewComponent,
    SanitizeHtmlPipe,
    SideMenuLiveViewComponent,
    AddProjetoComponent,
    ModalComponent,
    ReportComponent,
    CompileDirective,
    DynamicComponent,
    AddTenantComponent,
    AddDatasetComponent,
    AddCabecalhoComponent,
    EditorTemplateComponent,
    EditorCabecalhoComponent,
    JsonViewerComponent,
    ToastsContainer,
    AddTemplateComponent,
    ToastComponent,
    ModalperguntaComponent,
    ModalcloneComponent,
    ModaltooltipComponent
  ],
  entryComponents: [DynamicComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    CompileModule,
    RouterModule.forRoot([
      { path: 'edicoes', component: CounterComponent,canActivate: [AuthGuard] },
      { path: 'fetch-data', component: FetchDataComponent,canActivate: [AuthGuard] },
      { path: 'relatorio/:idDistinctor/:idReport', component: ReportComponent },
      { path: 'relatorio/:idReport', component: ReportComponent },
      { path: 'editorTemplate/:idReport', component: EditorTemplateComponent, canActivate: [AuthGuard] },
      { path: 'editorCabecalho/:idReport', component: EditorCabecalhoComponent, canActivate: [AuthGuard] },
      { path: 'account', loadChildren:() => import('./views/account/account.module').then(m => m.AccountModule) },
      { path: '', component: HomeComponent, canActivate: [AuthGuard] },

    ]),
    NgbModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatSidenavModule,
    MonacoEditorModule,
    CdkTableModule,
    ReactiveFormsModule
  ],
  providers: [
    RequestsService,
    ModalComponent,
    ModalperguntaComponent,
    JsonViewerComponent,
    HttpConfigInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
